import { Typography } from "@mui/material";
import Spreadsheet from "react-spreadsheet";

const fivePaid = 'fivePaid';
const sixPaid = 'sixPaid';
const sevenPaid = 'sevenPaid';
const eightPaid = 'eightPaid';
const fiveUnpaid = 'fiveUnpaid';
const sixUnpaid = 'sixUnpaid';
const sevenUnpaid = 'sevenUnpaid';
const eightUnpaid = 'eightUnpaid';
const fivePaidbyCard = 'fivePaidByCard';
const SixPaidbyCard = 'SixPaidByCard'; 
const SevenPaidbyCard = 'sevenPaidByCard'; 
const eightPaidbyCard = 'eightPaidByCard';
const totalPaidByCard = 'totalPaidByCard';
const totalFivePaid = 'totalFivePaid';
const totalSixPaid = 'totalSixPaid' 
const totalSevenPaid = 'totalSevenPaid'; 
const totalEightPaid = 'totalEightPaid'; 
const totalFiveUnpaid = 'totalFiveUnpaid'; 
const totalSixUnpaid ='totalSixUnpaid'; 
const totalSevenUnpaid= 'totalSevenUnpaid'; 
const totalEightUnpaid = 'totalEightUnpaid';      
const intermediate = 'intermediate';
const total = 'total';
const unpaid = 'unpaid';
const forMe = 'forMe';
const otherExpenses = 'otherExpenses';
const leftOver = 'leftOver';

// convert EUR TO BGN 1.95583
// convert BGN TO EUR 0.511292

const TableData = ({ rows, setRows, checkedTable }) => {
  const calculatePrice = (updatedTable) => {

    let totalFiveSum = 0;
    let totalSixSum = 0; 
    let totalSevenSum = 0; 
    let totalEightSum = 0;
    let fiveCardSum = 0; 
    let sixCardSum = 0;
    let sevenCardSum = 0;
    let eightCardSum = 0;
    let totalCardSum = 0;
    let totalFiveUnpaidSum = 0; 
    let totalSixUnpaidSum = 0; 
    let totalSevenUnpaidSum = 0; 
    let totalEightUnpaidSum = 0;
    let intermediateSum = 0;
    let forMeSum = 0;
    let otherExpensesSum = 0;
    let totalSum = 0;
    let totalUnpaidSum = 0;
    let moneyAfterPaying = 0;
    
   const calculation = updatedTable.map((row) => {
       
          row.forEach((cell) => {
            switch (cell.id) {
              case fivePaid:
                  if (cell.value !== '') totalFiveSum += parseFloat(cell.value);
                  break;
              case sixPaid:
                  if (cell.value !== '') totalSixSum += parseFloat(cell.value);
                  break;
              case sevenPaid:
                  if (cell.value !== '') totalSevenSum += parseFloat(cell.value);
                  break;
              case eightPaid:
                  if (cell.value !== '') totalEightSum += parseFloat(cell.value);
                  break;
              case fiveUnpaid:
                  if (cell.value !== '') totalFiveUnpaidSum += parseFloat(cell.value);
                  break;
              case sixUnpaid:
                  if (cell.value !== '') totalSixUnpaidSum += parseFloat(cell.value);
                  break;
              case sevenUnpaid:
                  if (cell.value !== '') totalSevenUnpaidSum += parseFloat(cell.value);
                  break;
              case eightUnpaid:
                  if (cell.value !== '') totalEightUnpaidSum += parseFloat(cell.value);
                  break;
              case fivePaidbyCard:
                   if (cell.value !== '') fiveCardSum = parseFloat(cell.value);
                  break;
              case SixPaidbyCard:
                   if (cell.value !== '') sixCardSum = parseFloat(cell.value);
                  break;
              case SevenPaidbyCard:
                   if (cell.value !== '') sevenCardSum = parseFloat(cell.value);
                  break;
              case eightPaidbyCard:
                   if (cell.value !== '') eightCardSum = parseFloat(cell.value);
                  break;
              case intermediate:
                  if (cell.value !== '') intermediateSum += parseFloat(cell.value);
                  break;
              case totalFivePaid: cell.value = totalFiveSum + fiveCardSum;
                  break;
              case totalSixPaid: cell.value = totalSixSum + sixCardSum;
                  break;
              case totalSevenPaid: cell.value = totalSevenSum + sevenCardSum;
                  break;
              case totalEightPaid: cell.value = totalEightSum + eightCardSum;
                  break;
              case totalFiveUnpaid: cell.value = totalFiveUnpaidSum;
                  break;
              case totalSixUnpaid: cell.value = totalSixUnpaidSum;
                  break;
              case totalSevenUnpaid: cell.value = totalSevenUnpaidSum;
                  break;
              case totalEightUnpaid: cell.value = totalEightUnpaidSum;
                  break;
              case total:
                  totalSum = ((totalFiveSum + totalFiveUnpaidSum + fiveCardSum) * 3.00128404) +
                             ((totalSixSum + totalSixUnpaidSum + sixCardSum) * 3.5023502) +
                             ((totalSevenSum + totalSevenUnpaidSum + sevenCardSum) * 3.99830344) +
                             ((totalEightSum + totalEightUnpaidSum + eightCardSum) * 4.4993696) + 
                             intermediateSum;
                  cell.value = totalSum.toFixed(2);
                  break;
              case unpaid:
                  totalUnpaidSum = (totalFiveUnpaidSum * 3.00128404) + 
                                   (totalSixUnpaidSum * 3.5023502) + 
                                   (totalSevenUnpaidSum * 3.99830344) + 
                                   (totalEightUnpaidSum * 4.4993696);
                  cell.value = totalUnpaidSum.toFixed(2);
                  break;
              case totalPaidByCard:
                totalCardSum = (fiveCardSum * 3.00128404) + (sixCardSum * 3.5023502)
                + (sevenCardSum * 3.99830344) + (eightCardSum * 4.4993696);
                cell.value = totalCardSum.toFixed(2);
                  break;
              case forMe:
                  if (cell.value !== '') forMeSum += parseFloat(cell.value);
                  break;
              case otherExpenses:
                  if (cell.value !== '') otherExpensesSum += parseFloat(cell.value);
                  break;
              case leftOver:
                moneyAfterPaying = cell.value = totalSum - (totalCardSum + totalUnpaidSum + forMeSum + otherExpensesSum);
                  cell.value = moneyAfterPaying.toFixed(2);
                  break;
              default: break;
          }
           return cell;
       });
       return row;
   }); 

    const newTable = structuredClone([...calculation]);
    setRows(newTable);
  };

  return (
  <>
  {checkedTable === 2 && <Typography variant="h2" textAlign="center" color="#ffeb3b">Прегледана</Typography>}
  {checkedTable === 3 && <Typography variant="h2" textAlign="center" color="primary">Проверена</Typography>}
  <Spreadsheet
    data={rows}
    onChange={calculatePrice}
  />
  </>
  );
};

export default TableData;
